import { api } from '@/plugins/api';

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  getLaraRedirectionLink({ commit }, context) {
    console.log(context);
    return api.post(`lara/get-redirection-link`, { id: context.encryptedId, urlRedirect: context.urlRedirect })
  },
  getErrorLara({ commit }, context) {
    console.log(context);
    return api.post(`lara/get-error-lara`, { id: context.encryptedId });
  }
}

export default ({
    namespaced: true,
    state: state,
    mutations: mutations,
    getters: getters,
    actions: actions
})